// extracted by mini-css-extract-plugin
export var disabled = "_2h-5";
export var fileName = "_2h-b";
export var filePreview = "_2h-4";
export var hoverFilter = "_2h-6";
export var imageButton = "_2h-3 _2h-6";
export var imageButtonContainer = "_2h-2";
export var input = "_2h-7";
export var removeButton = "_2h-0";
export var removeButtonFile = "_2h-1";
export var spinner = "_2h-9";
export var spinnerContainer = "_2h-8";
export var videoContainer = "_2h-a _2h-6";